<template>
    <div class='orderDetail'>
        <myBanner :imgSrc="imgSrc"/>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><span @click="goBack()">返回</span></el-breadcrumb-item>
            <el-breadcrumb-item><span @click="goBack()">我的订单</span></el-breadcrumb-item>
            <el-breadcrumb-item>留学订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="showMobile">
            <div class="dashed"></div>
        </div>
        <!-- 表格区域 -->
        <div class="content">
            <div class="appInfo">
                <img src="~assets/img/book.png" alt="">
                <div class="orderName">{{orderName}}订单信息</div>
                <div class="modify" v-show="isShowPay" @click="dialogVisible = true">修改</div>
            </div>
            <!-- 表格 -->
            <div class="showInfo">
                <el-form :model="ruleForm" status-icon label-width="100px">
                     <el-form-item label="订单类型：" >
                        <span class="dialogStatus">{{partnerId}}</span>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="订单编号：" >
                                {{this.tableData.length ? this.tableData[0].orderNumber : ''}}
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="下单时间：" >
                                {{this.tableData.length ? this.tableData[0].createTime : ''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="价格：" >
                                <span class="dialogPrice">{{this.tableData.length ? this.tableData[0].price : ''}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="支付状态：" >
                                <el-tag type="danger" v-if='this.payStatus==1'>待支付</el-tag>
                                <el-tag type="success" v-else-if="this.payStatus==2">已支付成功</el-tag>
                                <el-tag type="warning" v-else-if="this.payStatus==3">转入退款</el-tag>
                                <el-tag v-else>已退款</el-tag>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学校名称：" prop="schoolName" >
                                {{ruleForm.schoolName}}
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="留学层次：" prop="level" >
                                {{ruleForm.level}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学生姓名：" prop="studentName" >
                                {{ruleForm.studentName}}
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学生性别：" prop="sex">
                                {{ruleForm.sex == 1 ? '男' : '女' }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="出生年月：" prop="birthday">
                                {{ruleForm.birthday2}}
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="身份证号：" prop="idCard">
                                 {{ruleForm.idCard}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="手机：" prop="mobile">
                                {{ruleForm.mobile}}
                            </el-form-item>
                        </el-col>
                         <el-col :md="12" :sm="24">
                            <el-form-item label="电话：" prop="telephone">
                                {{ruleForm.telephone ? ruleForm.telephone : '暂无'}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="QQ：" prop="qq">
                                {{ruleForm.qq ? ruleForm.qq : '暂无'}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="留言板：" prop="desc">
                        {{ruleForm.desc ? ruleForm.desc : '暂无'}}
                    </el-form-item>
                    <el-form-item label="订单状态：" >
                        <span class="dialogStatus">{{this.tableData.length ? this.tableData[0].orderStatus : ''}}</span>
                    </el-form-item>
                </el-form>
            </div>

            <div class="appInfo" v-show="isShowFileCont">
                <img src="~assets/img/book.png" alt="">
                <div>申请资料</div>
            </div>
            <!-- 资料列表 -->
            <div class="fileList showPc"
                v-loading="loading"
                element-loading-text="上传文件中"
                v-show="isShowFileCont">
                <el-table
                :data="fileData"
                border
                style="width: 100%">
                    <el-table-column
                        prop="conditionName"
                        label="申请文件"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="400px">
                        <template slot-scope="scope">
                            <!-- <a v-show="scope.row.fileUrl" :href="url + scope.row.fileUrl">下载查看</a> -->
                            <span class="look" v-show="scope.row.fileUrl" @click="lookFile(scope.row)">下载查看</span>
                            <span v-show="!scope.row.fileUrl">暂无文件</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="修改资料"
                        align="center">
                        <template slot-scope="scope">
                            <input class="fileInput" type="file" :id="'fileExport' + scope.row.id" @change="handleFileChange(scope.row.id)" ref="inputer">
                             <span class="uploadFile">上传文件</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 移动资料列表 -->
            <div class="applyMobile showMobile" v-show="isShowFileCont">
                <div class="applyItem" v-for="(item4,index4) in fileData" :key="index4">
                    <div class="fileName">{{item4.conditionName}}</div>
                    <div class="fileArea">
                        <div v-show="item4.fileUrl" @click="lookFile(item4)" class="fileInfo">
                            下载查看
                        </div>
                        <div class="tip" v-show="!item4.fileUrl">暂无文件</div>
                        <div class="addInput">
                            <input class="fileInput2" type="file" :id="'mFileExport' + item4.id" @change="handleFileChange(item4.id)">
                            <img src="~assets/img/addFile.png" alt="">
                        </div>
                    </div>
                </div>
                <div v-show="isShowFile" class="noData">暂无数据</div>
            </div>
            <div class="fotBtn">
                <MyButton butTxt="支付" class="payment" v-show="isShowPay" @btnClick="btnClick" />
            </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog
        :visible.sync="dialogVisible"
        :width="dialogWidth"
        title="修改"
        center
        :show-close="false"
        :before-close="handleClose"
        class="updata">
            <div>
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
                    <div class="dialogTip">注：学校名称、留学层次不可修改</div>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="订单编号：" >
                                {{this.tableData.length ? this.tableData[0].orderNumber : ''}}
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="下单时间：" >
                                {{this.tableData.length ? this.tableData[0].createTime : ''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="价格：" >
                                <span class="dialogPrice">{{this.tableData.length ? this.tableData[0].price : ''}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="支付状态：" >
                                <el-tag type="danger" v-if='this.payStatus==1'>待支付</el-tag>
                                <el-tag type="success" v-else-if="this.payStatus==2">已支付成功</el-tag>
                                <el-tag type="warning" v-else-if="this.payStatus==3">转入退款</el-tag>
                                <el-tag v-else>已退款</el-tag>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学校名称：" prop="schoolName" >
                                <el-input v-model="ruleForm.schoolName" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="留学层次：" prop="level" >
                                <el-input v-model="ruleForm.level" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学生姓名：" prop="studentName" >
                                <el-input v-model="ruleForm.studentName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学生性别：" prop="sex">
                                <el-radio-group v-model="ruleForm.sex">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="出生年月：" prop="birthday">
                                <el-date-picker type="date" v-model="ruleForm.birthday" value-format="yyyy-MM-ddTHH:mm:ss.000Z" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="身份证号：" prop="idCard">
                                <el-input v-model="ruleForm.idCard"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="手机：" prop="mobile">
                                <el-input v-model="ruleForm.mobile"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :md="12" :sm="24">
                            <el-form-item label="电话：" prop="telephone">
                                <el-input v-model.number="ruleForm.telephone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="QQ：" prop="qq">
                                <el-input v-model.number="ruleForm.qq"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="留言板：" prop="desc">
                        <el-input type="textarea" placeholder="请输入留言" v-model="ruleForm.desc" maxlength="500" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态：" >
                        <span class="dialogStatus">{{this.tableData.length ? this.tableData[0].orderStatus : ''}}</span>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                <el-button size="medium" @click="cancel">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 付款二维码 -->
        <el-dialog
        :visible.sync="codeVisible"
        width="310px"
        center
        :before-close="handleClose2">
            <div id="qrcode" ref="qrcode"></div>
            <div class="codeTip">
                请使用微信扫一扫<br/>扫描二维码支付
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getDataMixin } from "common/mixin.js"
    import { getThemeList } from "network/home.js"
    import { orderDetail, upLoad, order, updataFile, changeOrder, payOrder, queryOrder} from "network/application.js"
    import {isCellPhone, isCard} from "common/libs.js"
    import getPayOrder from "common/mobilePay"

    import QRCode from "qrcodejs2";
    export default {
        name:"orderDetail",
        mixins:[getDataMixin],
        data(){
            var checkIdCard = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入身份证号"));
                } else if (!isCard(value)) {
                    callback(new Error("请输入正确的身份证号!"));
                } else {
                    callback();
                }
            };
             var checkphone = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入手机号"));
                } else if (!isCellPhone(value)) {
                    callback(new Error("请输入正确的手机号!"));
                } else {
                    callback();
                }
            };
            var checkNumber = (rule, value, callback) => {
                if (value != "") {
                    if((/^[0-9]*$/).test(value) == false){
                        callback(new Error("请输入正确格式"));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            var checkPhone = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入电话"));
                } else if ((/^[0-9]*$/).test(value) == false) {
                    callback(new Error("请输入正确电话!"));
                } else {
                    callback();
                }
            };
            return{
                url:process.env.VUE_APP_WEB_URL,
                imgSrc:[],
                orderName:"",
                tableData:[],
                isShowPay:false,
                fileData:[],
                dialogVisible:false,
                payStatus:'',
                dialogWidth:'60%',
                orderNumber:'',
                applyCountryId:'',
                applySchoolId:'',
                partnerId:'',
                ruleForm:{
                    studentName:'',
                    level:'',
                    birthday:'',
                    birthday2:'',
                    sex:'',
                    desc:'',
                    schoolName:'',
                    telephone:'',
                    mobile:'',
                    idCard:'',
                    qq:'',
                },
                rules: {
                    studentName: [
                        { required: true, message: '请输入学生姓名', trigger: 'blur' }
                    ],
                    sex: [
                        { required: true, message: '请选择性别', trigger: 'change' }
                    ],
                    birthday: [
                        {required: true , message: '请选择时间', trigger: 'blur' }
                    ],
                    idCard: [
                        { required: true, validator: checkIdCard, trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, validator: checkphone, trigger: 'blur' }
                    ],
                    telephone: [
                        // { required: true, validator: checkPhone, trigger: 'blur' }
                        { required: false, validator: checkNumber, trigger: 'blur' }
                    ],
                    qq:[
                        { required: false, validator: checkNumber, trigger: 'blur' }
                    ]
                    
                },
                codeVisible:false,
                timer:'',
                queryTimer:'',
                loading:false,
                isShowFile:false,
                isShowFileCont:false,
                tradeType:'NATIVE',
                bridgeData:{}
            }
        },
        created(){
            this.getThemeListData(1,100)
            this.getOrderDetail()
            if(this.$IsMobile()){
                this.dialogWidth = '90%'
                this.tradeType = "JSAPI"
            }
        },
        methods:{
            // --接口请求 --
            getThemeListData(page,pageSize) {
                getThemeList({
                    page,
                    pageSize
                }).then(res => {
                    let data = res.data.records[this.getNavIndex - 1]
                    if(data){   
                        let bannerData = data.themeBanners
                        if(bannerData.length && bannerData.length == 2){
                            for(let i in bannerData){
                                bannerData.push(bannerData[i])
                            }
                            this.imgSrc = bannerData
                        }else if(bannerData.length){
                            this.imgSrc = bannerData
                        }
                    }
                });
            },
            // 订单详情
            getOrderDetail(){
                this.tableData = []
                orderDetail(this.id).then(res=>{
                    this.orderName = res.data.orderName;
                    this.fileData = res.data.wxUserApplyFileList
                    this.payStatus = res.data.payStatus
                    this.orderNumber = res.data.orderNumber
                    this.levelNumber = res.data.level
                    this.applyCountryId = res.data.applyCountryId
                    this.applySchoolId = res.data.applySchoolId
                    this.tableData.push({
                        orderNumber:res.data.orderNumber,
                        price:res.data.price ? '¥' + res.data.price  : 0,
                        studentName:res.data.studentName,
                        createTime:res.data.createTime ? res.data.createTime[0] + '.' + res.data.createTime[1] + '.' + res.data.createTime[2] + ' ' + res.data.createTime[3] + ':' + res.data.createTime[4] + ':' + res.data.createTime[5]: '暂无',
                        levelName:res.data.levelName,
                        birthday:res.data.birthday ? res.data.birthday[0] + '.' + res.data.birthday[1] + '.' + res.data.birthday[2] : '暂无',
                        payStatus:res.data.payStatus ,
                        orderStatus:res.data.orderStatus ? (res.data.orderStatus == 1 ? '进行中' : '已完成'  ) : '暂无状态',
                        sex:res.data.sex == 1 ? '男' : '女',
                        mobile:res.data.mobile,
                        telephone:res.data.telephone,
                        qq:res.data.qq? res.data.qq : '暂无',
                        message:res.data.message ? res.data.message : '暂无',
                        idCard:res.data.idCard,
                    })
                    if(res.data.payStatus == 1){
                        this.isShowPay = true
                    }else{
                        this.isShowPay = false
                    }
                    if(res.data.wxUserApplyFileList.length){
                        this.isShowFile = false
                    }else{
                        this.isShowFile = true
                    }
                    if(res.data.parentId == 0){
                        this.isShowFileCont = true
                    }else{
                        this.isShowFileCont = false
                    }
                    this.ruleForm.schoolName = res.data.schoolName
                    this.ruleForm.level = res.data.levelName
                    this.ruleForm.studentName = res.data.studentName
                    this.ruleForm.sex = res.data.sex
                    // this.ruleForm.birthday = res.data.birthday ? new Date(res.data.birthday[0] + '.' + res.data.birthday[1] + '.' + res.data.birthday[2] + ' 00:00:00.000Z') : '暂无'
                    this.ruleForm.birthday = res.data.birthday ? new Date(res.data.birthday[0] + '-' + res.data.birthday[1] + '-' + res.data.birthday[2]) : '暂无'
                    console.log(res.data.birthday[0] + '-' + res.data.birthday[1] + '-' + res.data.birthday[2])
                    this.ruleForm.birthday2 = res.data.birthday ? res.data.birthday[0] + '-' + res.data.birthday[1] + '-' + res.data.birthday[2] : '暂无'
                    this.ruleForm.idCard = res.data.idCard
                    this.ruleForm.mobile = res.data.mobile
                    this.ruleForm.telephone = res.data.telephone
                    this.ruleForm.desc = res.data.message
                    this.ruleForm.qq = res.data.qq,
                    this.partnerId = res.data.parentId == 0 ? '获取offer' : '获取签证'
                })
            },
            //修改接口
            changData(){
                let data = {
                    applyCountryId : this.applyCountryId,
                    applySchoolId : this.applySchoolId,
                    level : this.levelNumber,
                    studentName : this.ruleForm.studentName,
                    sex : this.ruleForm.sex,
                    birthday : new Date(this.ruleForm.birthday),
                    mobile : this.ruleForm.mobile,
                    telephone : this.ruleForm.telephone,
                    idCard : this.ruleForm.idCard,
                    qq : this.ruleForm.qq,
                    message : this.ruleForm.desc,
                    id:this.id,
                }
                changeOrder(data).then(res =>{
                    this.dialogVisible = false
                    this.$message({
                        type:"success",
                        message:"修改成功"
                    })
                    this.getOrderDetail()
                })
            },
            // 付款码
            getPayOrder(){
                payOrder({
                    outTradeNo:this.orderNumber,
                    tradeType:this.tradeType
                }).then(res=>{
                    clearInterval(this.queryTimer)
                    if(res.code == 1){
                        this.codeVisible = true
                        this.$nextTick(() => {
                            this.qrcode(res.data.codeUrl);
                        });
                        this.queryTimer = setInterval(()=>{
                            // 支付状态
                            this.queryOrder()
                        },2000)
                    }
                })
            },

            qrcode (codeUrl) {
                document.getElementById("qrcode").innerHTML = ""
                let qrcode = new QRCode("qrcode", {
                    width: 200, // 像素
                    height: 200,
                    text:codeUrl
                });
            },
            // 查询订单是否支付
            queryOrder(){
                queryOrder({
                    outTradeNo:this.orderNumber
                }).then(res=>{
                    console.log(res.data.tradeState)
                    if(res.code == 1 && res.data.tradeState == "SUCCESS"){
                        this.codeVisible = false
                        clearInterval(this.queryTimer)
                        this.getOrderDetail()
                        this.$message({
                            type:'success',
                            message:'支付成功'
                        })
                        setTimeout(()=>{
                            this.$router.push('/myOrder')
                        },2000)
                    }
                })
            },
            // 事件
            btnClick(){
                if(this.$IsMobile()){
                    // this.getMobilePayOrder()
                    getPayOrder({
                        orderNumber:this.orderNumber,
                        tradeType:this.tradeType
                    })
                }else{
                    this.getPayOrder()
                    // this.timer = setInterval(()=>{
                    //     this.getPayOrder()
                    // },110000)
                }
            },
            // 文件上传
            handleFileChange (id) {
                let file = ""
                if(this.$IsMobile()){
                    let inputDOM = document.getElementById('mFileExport' + id)
                    file = inputDOM.files[0]
                }else{
                    let inputDOM = document.getElementById('fileExport' + id)
                    file = inputDOM.files[0]
                }
                if(file){
                    this.loading = true
                    let formData = new FormData();//new一个formData事件
                    formData.append("file",file); //将file属性添加到formData里
                    updataFile(id,formData).then(res=>{
                        if(res.code == 1){
                            for(let i in this.fileData){
                                if(id == this.fileData[i].id){
                                    this.fileData[i].fileUrl = res.data.fileUrl
                                    this.fileData[i].fileName = res.data.conditionName
                                    // 及时修改数据
                                    this.$set(this.fileData,i,this.fileData[i])
                                }
                            }
                            this.$message({
                                type:'success',
                                message:'上传文件成功'
                            })
                        }else{
                            this.$message({
                                type:'error',
                                message:res.msg
                            })
                        }
                        this.loading = false
                    })
                }
            },
            // 修改
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.changData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleClose2(done){
                clearInterval(this.queryTimer)
                done();
            },
             // 查看文件
            lookFile(scope){
                let fileUrl = this.url + scope.fileUrl
                const imgReg = /\.(png|jpe?g|gif|svg)(\?.*)?$/
                const flag = imgReg.test(fileUrl)
                if(flag){
                    window.open(fileUrl)
                }else{
                    window.location.href = fileUrl
                }
            },
            cancel(){
                this.dialogVisible = false
                this.getOrderDetail()
            },
            handleClose(done) {
                this.getOrderDetail()
                done()
            },
            goBack(){
                this.$router.push({
                    path:'/myOrder',
                    query:{
                        page:this.linkPage,
                    }
                })
            }
        },
        destroyed(){
            clearInterval(this.queryTimer)
        },
        computed:{
            id(){
                return this.$route.query.id ? this.$route.query.id : "" 
            },
            linkPage(){
                return this.$route.query.page ? this.$route.query.page : "" 
            }
        }
    }
</script>
<style scoped lang="scss">
    .showInfo .el-form-item {
        margin-bottom: 12px;
    }
    .showInfo{
        margin-bottom: 20px;
    }
    .el-breadcrumb__inner span{
        cursor: pointer;
    }
    .el-table .orderStatus{
        color:var(--color-main);
    }
    .dialogPrice{
        color:rgba(250, 85, 85, 1);
    }
    .dialogStatus{
        color:var(--color-main);
    }
    .el-dialog .dialogTip{
        color:rgba(250, 85, 85, 1);
        font-size:14px;
        padding-left:18px;
        margin-bottom: 10px;
    }
    #qrcode {
        padding-left:30px;
    }
    .codeTip{
        text-align: center;
        background:var(--color-main);
        color:#fff;
        width:200px;
        margin:20px auto 0;
        padding:5px 0;
        line-height: 20px;
    }
    .content{
        margin:30px 0 40px;
        .appInfo{
            background:var(--color-bg-main) ;
            display: flex;
            align-items: center;
            padding:10px 20px;
            margin:0px 0 20px;
            font-size:14px;
            position: relative;
            img{
                width: 20px;
                margin-right:10px;
            }
            .modify{
                position: absolute;
                top: 12px;
                right: 20px;
                color:var(--color-main);
                text-decoration: underline;
                cursor: pointer;
                font-weight: bold;
            }
        }
        .orderTable{
            border:1px solid #EBEEF5;
            border-bottom:0;
            margin-bottom:30px;
        }
        .fotBtn{
            .payment{
                background: rgba(255, 141, 26, 1);
            }
        }
        .fileList{
            margin-bottom: 30px;
            span.look{
                color:var(--color-main);
                text-decoration: underline;
                cursor: pointer;
            }
            span.uploadFile{
                color:var(--color-main);
            }
            .fileInput{
                background: red;
                width:200px;
                position: absolute;
                top:12px;
                left:100px;
                opacity: 0;
            }
        }
    }

@media screen and (max-width: 768px){
    .showInfo .el-form-item {
        margin-bottom: 0.1rem;
    }
    .showInfo{
        margin-bottom: 0.4rem;
    }
    .el-dialog .dialogTip{
        font-size:0.28rem;
    }
    .content{
        width: 90%;
        margin: 0.4rem auto;
        .appInfo{
            padding:0.2rem 0.3rem;
            margin:0px 0 0.2rem;
            font-size:0.28rem;
            position: relative;
            padding-left:0.8rem;
            img{
                width: 0.3rem;
                margin-right:0.2rem;
                position:absolute;
                top:0.2rem;
                left:0.3rem;
            }
            .orderName{
                width:80%;
            }
            .modify{
                position: absolute;
                top: 0.2rem;
                right: 0.3rem;
            }
        }
    }
    .applyMobile{
        font-size:0.3rem;
        .fileArea{
            border:1px solid var(--color-border);
            border-radius: 3px;
            padding:0.15rem;
            margin:0.15rem 0 0.3rem 0;
            color:#727375;
            font-size:0.28rem;
            .tip{
                margin-bottom:0.15rem;
            }
            .fileInfo{
                color:var(--color-main);
                margin-bottom:0.15rem;
            }
            .addInput{
                position: relative;
                .fileInput2{
                    width:0.7rem;
                    height:0.7rem;
                    position: absolute;
                    top:0px;
                    left:0px;
                    opacity: 0;
                }
                img{
                    width:0.7rem;
                }
            }
            
        }
        .noData{
            text-align: center;
            margin-bottom:0.5rem;
        }
    }
}
</style>